module.exports = __webpack_public_path__ + "img/android.281c9374.png";